import { FC } from 'react'
import cn from 'classnames'
import classes from '../styles/skeleton.module.scss'


export const Skeleton: FC<{ type: 'avatar' | 'card' | 'list-item' | 'group-card' }> = ({ type }) => {

    return <div className={cn(
        classes.skeleton,
        type === 'avatar' && classes.skeletonAvatar,
        type === 'card' && classes.skeletonCard,
        type === 'list-item' && classes.skeletonListItem,
        type === 'group-card' && classes.skeletonGroupCard,
    )}> </div>
}
